module.exports = __webpack_public_path__ + "static/media/example599274916.d9061d3d.mp4";